<template>
  <div id="app">
    <v-app id="inspire">
      <v-content >
        <v-container
          fluid
          fill-height
        >
          <v-layout
            align-center
            justify-center
          >
            <v-flex
              xs12
              sm8
              md4
            >
              <v-card
                class="text-center"
                id="petfound"
              >
               
                <h2 class="mt-5">¡Aquí podría estar tu mascota!</h2>
                <v-btn
                    to="/"
                    class="mt-2"
                    color="#FB8C00"
                    style="text-transform:none;color:#fff;"
                    rounded=""
                    >
                        Saber más
                      </v-btn>
                <div >
                  <!-- <v-avatar
                    size="82"
                    class="mb-5 mt-5"
                  > -->
                    <!--suppress HtmlUnknownTarget -->
                    <v-img
                      :src="imgPetAvatar"
                      aspect-ratio="1.4" 
                      contain
                    ></v-img>
                  <!-- </v-avatar> -->
                </div>

                <div class="name">
                  <h1>{{ petDetail.name }}</h1>
                </div>
                <v-card-text>
                  <v-row
                    align="center"
                    justify="space-between"
                  >
                    <div class=" items_pet">
                      <div>
                        <h2>
                          Raza
                        </h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.race }}</strong>
                      </p>
                    </div>
                    <div class=" items_pet">
                      <div>
                        <h2>
                          Cumpleaños
                        </h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.dateBirth }}</strong>
                      </p>
                    </div>
                    <div class=" items_pet">
                      <div>
                        <h2>
                          Edad
                        </h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.age }}</strong>
                      </p>
                    </div>
                    <div class=" items_pet">
                      <div>
                        <h2>
                          Género
                        </h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.gender }}</strong>
                      </p>
                    </div>
                    <div class=" items_pet">
                      <div>
                        <h2>
                          Especie
                        </h2>
                      </div>

                      <p>
                        <strong>{{ petDetail.species }}</strong>
                      </p>
                    </div>
                  </v-row>
                  <!-- Owner info -->
                  <v-row
                    align="center"
                    justify="space-between"
                    v-if="petDetail.owner.userprofile.shareProfile"
                  >
                    <v-col
                      cols="12"
                    >
                      <h2>Información de mi dueño</h2>
                      <v-list three-line>
                        <v-divider />

                        <v-list-item>
                          <v-list-item-avatar>
                            <!--suppress HtmlUnknownTarget -->
                            <v-img :src="imgAvatar" />
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title v-html="`<strong>${petDetail.owner.name} ${petDetail.owner.lastName}</strong>`"></v-list-item-title>
                            <v-list-item-subtitle v-html="getOwnerAddress()"></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />

                        <v-subheader
                          v-html='`<div style="text-align: left">Teléfono: ${petDetail.owner.phoneNumber} <br> Email: <a href="${petDetail.owner.email}">${petDetail.owner.email}</a> </div>`'
                        ></v-subheader>

                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <v-col>
                      <div>
                      <h4 style="color:#01579B;">Ayúdame a regresar</h4>
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        color="green"
                      >
                        <v-icon>mdi-whatsapp</v-icon>
                      </v-btn>
                    </div>
                    <v-btn
                    to="/"
                    class="mt-5"
                    color="#FB8C00"
                    style="text-transform:none;color:#fff;"
                    rounded=""
                    >
                        Saber más
                      </v-btn>
                    </v-col>
                  </v-row>
                  
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-snackbar
        v-model="snackbar"
      >
        {{ snackbarText }}
        <v-btn
          color="pink"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        imgAvatar: 'https://randomuser.me/api/portraits/men/34.jpg',
        imgPetAvatar: 'https://cardexbuckettesca.s3.us-west-2.amazonaws.com/obipets/Schnauzer.png',
        snackbar: false,
        snackbarText: '',
        petCode: null,
        petDetail: {
          name: 'Fido',
          species: 'Perro',
          gender: 'Macho',
          dateBirth: '2016/05/05',
          age: '4',
          race: 'Schnauzer',
          sterilized: 'Si',
          vaccinated: 'Si',
          coexistAnimals: 'Si',
          coexistAnimalsDescription: 'Si',
          coexistLittleChill: 'Si',
          coexistAncient: 'Si',
          sickness: 'No',
          sicknessDescription: '',
          allergies: 'Si',
          allergiesDescription: 'Es alergico a la comida',
          notes: 'Es un poco timido.',
          image: this.imgPetAvatar,
          owner: {
            id: '1',
            username: 'Carlos',
            name: 'Carlos',
            lastName: 'Vargas',
            email: 'carlos@midominio.com',
            phoneNumber: '+525531182995',
            userprofile: {
              id: '1',
              picture: this.imgAvatar,
              street: 'Balboa',
              extNum: '1337',
              intNum: '15',
              postalCode: '85004',
              settlement: 'Gustavo a Madero',
              city: 'México',
              municipality: '',
              estate: '',
              shareProfile: true
            }
          }
        }
      }
    },
   
    methods: {
      getOwnerAddress() {
        if(this.petDetail.owner.userprofile.settlement !== ''){
          let address = `${this.petDetail.owner.userprofile.street} ext ${this.petDetail.owner.userprofile.extNum}`;

          // Numero interno
          if (this.petDetail.owner.userprofile.intNum !== '' || this.petDetail.owner.userprofile.intNum !== null ) {
            address += `, int ${this.petDetail.owner.userprofile.intNum}`
          }
          // Colonia
          if (this.petDetail.owner.userprofile.settlement !== '' || this.petDetail.owner.userprofile.settlement !== null ) {
            address += `, Col. ${this.petDetail.owner.userprofile.settlement}`
          }
          // Ciudad
          if (this.petDetail.owner.userprofile.city !== '' || this.petDetail.owner.userprofile.city !== null ) {
            address += `, Cd. ${this.petDetail.owner.userprofile.city}`
          }

          // Municipio
          if (this.petDetail.owner.userprofile.municipality !== '' || this.petDetail.owner.userprofile.municipality !== null ) {
            address += `, ${this.petDetail.owner.userprofile.municipality}`
          }

          // Estado
          if (this.petDetail.owner.userprofile.estate !== '' || this.petDetail.owner.userprofile.estate !== null ) {
            address += `, ${this.petDetail.owner.userprofile.estate}`
          }

          // Código postal
          if (this.petDetail.owner.userprofile.postalCode !== '' || this.petDetail.owner.userprofile.postalCode !== null ) {
            address += `, CP. ${this.petDetail.owner.userprofile.postalCode}`
          }

          return address;
        }else{
          let message = "No hay mas información disponible por el momento."
          return message;
        }

      }
    
  
    }
  }
</script>
<style lang="scss" scoped>
  #petfound{
    background-image: url('../../assets/img/backgrounds/fondoblanco.png');
    background-size: cover;
  }
  .name{
    width: 50%;
    margin: 15px 0 0 25%;
    h1{
      color:#fff;
      background-color: #A7C84B;
      height:inherit;

      border-radius: 10px 10px 10px 10px;
      -moz-border-radius: 10px 10px 10px 10px;
      -webkit-border-radius: 10px 10px 10px 10px;
      border: 0px solid #000000;
    }

  }
  .items_pet{
    div{
      background-color: #A7C84B;
      height: inherit;
      width: inherit;
      border-radius: 5px;
      border: 0px solid #000000;
      margin: 5px;
    }
    h2{
      color:#fff;
      margin: 0 10px 0 10px;
    }
    p{
      color: #568b3f;
    }
  }

  .v-list--three-line .v-list-item .v-list-item__subtitle, .v-list-item--three-line .v-list-item__subtitle,
  .v-list-item__title {
    text-align: left !important;
  }
</style>
